import CountriesWidget from './CountriesWidget';
export default CountriesWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CountriesWidget/index.js